import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  isSidebarOpen = false;
  selectedComponent = 'grupo';

  constructor() {}

  ngOnInit() {}

  onSidebarStateChange(isOpen: boolean) {
    this.isSidebarOpen = isOpen;
  }

  onMenuItemClick(component: string) {
    this.selectedComponent = component;
  }
}
